var map = {
	"./en/_privacy.json": 60839,
	"./en/about.json": 49740,
	"./en/accept-cookie.json": 12341,
	"./en/affiliate-terms.json": 39363,
	"./en/apps.json": 46807,
	"./en/common.json": 40464,
	"./en/contact-us.json": 1260,
	"./en/cookie-policy.json": 37731,
	"./en/customer-support.json": 84732,
	"./en/discord-email.json": 97771,
	"./en/discord-telegram-privacy.json": 95307,
	"./en/discord-telegram.json": 81165,
	"./en/footer.json": 65428,
	"./en/header.json": 1198,
	"./en/hire.json": 39171,
	"./en/home.json": 12482,
	"./en/privacy.json": 2297,
	"./en/reactFlow.json": 38547,
	"./en/recharge.json": 68274,
	"./en/selectors.json": 66122,
	"./en/suggestion.json": 87302,
	"./en/terms-of-use.json": 31475,
	"./en/training.json": 68007,
	"./uk/about.json": 54019,
	"./uk/accept-cookie.json": 59142,
	"./uk/apps.json": 80779,
	"./uk/common.json": 98783,
	"./uk/contact-us.json": 3182,
	"./uk/cookie-policy.json": 26562,
	"./uk/customer-support.json": 80205,
	"./uk/discord-email.json": 49233,
	"./uk/discord-telegram-privacy.json": 5669,
	"./uk/discord-telegram.json": 42785,
	"./uk/footer.json": 38350,
	"./uk/header.json": 57334,
	"./uk/hire.json": 64002,
	"./uk/home.json": 58133,
	"./uk/privacy.json": 10966,
	"./uk/reactFlow.json": 78177,
	"./uk/recharge.json": 759,
	"./uk/selectors.json": 68474,
	"./uk/suggestion.json": 71158,
	"./uk/terms-of-use.json": 16579,
	"./uk/training.json": 65802
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56848;